import React, {Component, createRef} from 'react'
import styles from './FJRelinkModal.module.less';
import FJLocalStore from "../../../store/FJLocalStore";
import FJInputFile from "fj-components/FJInputFile"
import FJCustomScroll from "../../../common/component/FJCustomScroll";
import InlineSVG from "react-inlinesvg";
import relinkGray from "../../../icon/relink-gray.svg";
import relinkSuccess from "../../../icon/relink-success.svg";
import FJButtonSemicircle from "../../../common/component/button-semicircle/FJButtonSemicircle";
import FJUtil from "../../../util/FJUtil";
import $ from 'jquery';
import FJConfig from "../../../config/FJConfig";
import smallLoadingSvg from '../../../icon/smallLoading.svg';

class LinkItem extends Component {

  constructor(props) {
    super(props);
    this._linkFail = React.createRef();
  }

  /**
   * @description 显示link fail的文字
   */
  showLinkFail = () => {
    $(this._linkFail .current).show();
  };

  /**
   * @description 隐藏link fail的文字
   */
  hideLinkFail = () => {
    $(this._linkFail .current).hide();
  };

  /**
   * @description 显示对应状态下的icon
   * @returns {*}
   * @private
   */
  _getIcon = () => {
    let {isLoading, isLinked, linkClick} = this.props;
    if (isLoading) {
      return <InlineSVG src={smallLoadingSvg} className={styles.link_loading} />;
    } else {
      if (isLinked) {
        return <InlineSVG element='div' src={relinkSuccess}/>;
      } else {
        return <div className={styles.link_icon}><InlineSVG element='div' className={styles.link} src={relinkGray} onClick={linkClick}/></div>;
      }
    }
  };

  render() {
    let {
      name
    } = this.props;
    let {fileText} = FJUtil.getEspText(name, 14, 374);

    return (
      <div className={styles.item_link}>
        <div className={styles.item_link_top}>
          <p className={styles.link_name}>{fileText}</p>
          {this._getIcon()}
        </div>
        <p ref={this._linkFail} className={styles.link_error}>{FJLocalStore._('no-matching-files-were-found')}</p>
      </div>
    )
  }
}

class FJRelinkModal extends Component {

  constructor(props) {
    super(props);
    this._inputFile = React.createRef();
    this._reconnectInputFile = React.createRef();
    this._folderError = React.createRef();
		this.scrollRef  = createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
		this.scrollRef.current.scrollTop(0, true)
	}

	/**
   * @description 用户点击reconnect
   * @private
   */
  _reconnect = () => {
    this._linkId = null;
    this._reconnectInputFile.current.click();
  };

  /**
   * @description 用户点击link icon
   * @private
   */
  _linkClick = (id) => {
    this._linkId = id;
    this._inputFile.current.click();
  };

  /**
   * @description 返回link的所有
   * @returns {Array}
   * @private
   */
  _getLinks = () => {
    let list = this.props.linkMediaList;
    return list.map((item, index) => (
      <LinkItem key={item.id + item.name + item.type}
                ref={(ele) => {this['linkItem' + item.id] = ele}}
                index={index}
                name={item.name}
                isLinked={item.isLinked}
                isLoading={item.isLoading}
                linkClick={() => {this._linkClick(item.id)}}
      />
    ));
  };

  /**
   * @description 上传文件夹
   * @param e
   * @private
   */
  _inputUpdate = (e) =>{
    let files = e.target.files;
		this.props.cutRelinkBtn();
    this.props.linkMedias(files, this._linkId, () => {
      if (this._linkId) {
        this['linkItem' + this._linkId].showLinkFail();

        if(this._timeID) {
          clearTimeout(this._timeID);
        }
        this._timeID = setTimeout(() => {
          this['linkItem' + this._linkId].hideLinkFail();
        }, FJConfig.timeLink * 1000);

        try {
          this._inputFile.current.val("");
        } catch (err) {
          console.log(err);
        }
      } else {

        this._showReconnectLinkFail();

        if(this._timeID) {
          clearTimeout(this._timeID);
        }
        this._timeID = setTimeout(() => {
          this._hideReconnectLinkFail();
        }, FJConfig.timeLink * 1000);

        try {
          this._reconnectInputFile.current.val("");
        } catch (err) {
          console.log(err);
        }
      }
    });
  };

  _showReconnectLinkFail = () => {
    $(this._folderError.current).show();
  };

  _hideReconnectLinkFail = () => {
    $(this._folderError.current).hide();
  };

  render() {
    let {
      onSubmit,
      onCancel,
      linkMediaList,
			isShowRelinkBtn
    } = this.props;

    let height;
    if (linkMediaList.length > 5) {
      height = 216;
    } else {
      height = 20 + linkMediaList.length * 37 + 2;
    }

    return (
      <div className={styles.box}>
				{
					isShowRelinkBtn ? <div className={styles.reconnect}>
						<FJButtonSemicircle text={FJLocalStore._('reconnect-entire-folder')}
																className={styles.reconnect_btn}
																size='large'
																onClick={this._reconnect}
						/>
						<FJInputFile ref={this._reconnectInputFile} folder={true} multiple accept='image/*, video/*, audio/*'
												 onChange={this._inputUpdate}/>
					</div> : <div className={styles.reconnect}><Preparing /></div>
				}
        <div className={styles.desc}>{FJLocalStore._('select-folder')}</div>
        <div className={styles.folder_error} ref={this._folderError}>
          {FJLocalStore._('link-folder-fail')}
        </div>
        <div className={styles.relink_box}>
          <div className={styles.relink_inner} style={{height: height}}>
            <FJCustomScroll ref={this.scrollRef}>
              <div className={styles.links}>
                {this._getLinks()}
                <FJInputFile ref={this._inputFile} multiple accept='image/*, video/*, audio/*'
                             onChange={this._inputUpdate}/>
              </div>
            </FJCustomScroll>
          </div>
        </div>
        <div className={styles.footer}>
          <FJButtonSemicircle text={FJLocalStore._('cancel')}
                              className={styles.cancel}
                              size='large'
                              onClick={onCancel}
                              type='cancel'
          />
          <FJButtonSemicircle text={FJLocalStore._('confirm')}
                              className={styles.confirm}
                              size='large'
                              onClick={onSubmit}
          />
        </div>
      </div>
    );
  }
}

function Preparing() {

	return (
		<>
			<FJButtonSemicircle text={FJLocalStore._('Preparing')}
													className={styles.reconnect_preparing_btn}
													size='large'
													ghost
			/>
			<div className={styles.loading_box}>
				{/* <div className={styles.loading_box_circle}> </div> */}
				{/* <div className={styles.loading_box_circle_empty}> </div> */}
				<InlineSVG src={smallLoadingSvg} />
			</div>
		</>
	);
}


export default FJRelinkModal;
